export const useCustomerStore = defineStore('customer', () => {
  const data = ref<CustomerData | null>(null)

  const resetPwEmail = ref<string | null>(null)

  const contract = ref<CustomerContract | null>(null)
  const credits = ref<Credit[] | null>(null)
  const paymentData = ref<CustomerPaymentData | null>(null)
  const tariff = ref<Tariff | null>(null)

  const bahnBonusCookie = useCookie<BahnBonusCookie | null>('dbc-nc')
  const tariffForChange = ref<Tariff | null>(null)
  const buesinessParamForChange = ref<string>('')

  const isLoadingContracts = ref<Boolean>(true)

  const totalCredits = computed<string>(() => {
    if (credits.value) {
      let total = 0
      credits.value.forEach((credit: Credit) => (total += credit.value))
      return getCurrencyString(total)
    } else {
      return getCurrencyString(0)
    }
  })

  async function getData() {
    const response = await useFetchCustomerData()
    data.value = response.value
  }

  async function getContracts() {
    const response = await useFetchCustomerContracts()
    contract.value = response.value

    if (response.value?.credits) {
      credits.value = response.value.credits.filter(
        (credit: Credit) => new Date() < new Date(credit.validTo)
      )
    }

    if (response.value?.paymentData) {
      paymentData.value = response.value?.paymentData
    }

    if (response.value?.tariff) {
      tariff.value = response.value.tariff
    }
    isLoadingContracts.value = false
  }

  async function getBahnBonusData() {
    if (bahnBonusCookie.value && bahnBonusCookie.value.actioncode) {
      buesinessParamForChange.value = bahnBonusCookie.value.leistungselementid

      const response = await fetchTariffs(
        bahnBonusCookie.value.actioncode,
        useNuxtApp().$i18n.locale.value
      )
      if (response._data?.data[0]) {
        tariffForChange.value = response._data.data[0]
      }
    }
  }

  function removeBahnBonusData() {
    bahnBonusCookie.value = null
    tariffForChange.value = null
    buesinessParamForChange.value = ''
  }

  function $reset() {
    data.value = null
    contract.value = null
    credits.value = null
    paymentData.value = null
    tariff.value = null
    bahnBonusCookie.value = null
    tariffForChange.value = null
    buesinessParamForChange.value = ''
    resetPwEmail.value = null
  }

  return {
    data,
    contract,
    credits,
    totalCredits,
    paymentData,
    tariff,
    resetPwEmail,
    getData,
    getContracts,
    $reset,
    getBahnBonusData,
    removeBahnBonusData,
    tariffForChange,
    buesinessParamForChange,
    isLoadingContracts,
  }
})
